<div class="head-w">
    <div class="offerschedule">
        <mat-icon class="unsetico">event</mat-icon>
        <span multilang class="offerscheduletext">
            <b>{{datas?.CustomOffer?.Accommodation?.DurationDays + ' ' +
                datas?.CustomOffer?.Accommodation?.DurationUnit}}</b>
            {{datas?.CustomOffer?.Accommodation?.StartDate | date:'dd.MM.yyyy'}} -
            {{datas?.CustomOffer?.Accommodation?.EndDate | date:'dd.MM.yyyy'}}
        </span>
    </div>
    <div class="offerinfos">
        <div>
            <!--span class="fpadlr mtop" style="font-size: .8rem;">Flug</span-->
            <div class="fdropw mtop mbottom">
                <b>
                    {{datas?.CustomOffer?.Accommodation?.City}}
                    {{datas?.CustomOffer?.Accommodation?.Country}}
                    <br><br>{{datas?.CustomOffer?.Accommodation?.AccommodationName}}</b>
            </div>
            <mat-divider></mat-divider>
            <div class="fdropw mbottom">
                <mat-icon class="ficon">bedroom_child</mat-icon>
                <span multilang
                    class="fpadlr">{{datas?.CustomOffer?.Accommodation?.AccommodationTypeDescription}}</span>
            </div>
            <div class="fdropw mtop">
                <span multilang class="fpadlr">{{datas?.CustomOffer?.Accommodation?.BoardDescription}}</span>
            </div>
        </div>
    </div>
    <div class="offerprice">
        <div>
            <span multilang *ngIf="datas?.CustomOffer?.PAX?.length > 0">Erwachsene :
                {{datas?.CustomOffer?.PAX}}</span>
            <span multilang style="margin-left: .5rem;" *ngIf="datas?.CustomOffer?.ChildrenCount?.length > 0">Kinder :
                {{datas?.CustomOffer?.ChildrenCount}}</span>
        </div>
        <div class="offerpriceTotal">
            <span multilang>Gesamtpreis:</span>
            <span multilang class="prccolor">{{datas?.CustomOffer?.Accommodation?.Price | number:'1.2-2'}}
                {{datas?.CustomOffer?.Accommodation?.Currency}}</span>
        </div>
    </div>
</div>